
  import { computed, defineComponent, PropType } from 'vue';

  import { TRepresentativeAbroadListInfo } from '@/modules/ves/types/regionDashboards';

  export default defineComponent({
    name: 'RegionDashBoardsRepresentativeInfoList',
    props: {
      representativeAbroadInfo: {
        type: Object as PropType<TRepresentativeAbroadListInfo>,
        required: false,
      },
    },
    setup(props) {
      const contactInfoItems = computed(() => {
        return (
          props.representativeAbroadInfo?.contactInfo?.split(/\r\n|\n|;/).filter((item: string) => item.trim()) ?? []
        );
      });

      const positionFull = computed(() => props.representativeAbroadInfo?.positionFull);

      return {
        contactInfoItems,
        positionFull,
      };
    },
  });
